export enum Period {
	ALL_YEAR_ROUND = 'ALL_YEAR_ROUND',
	HOLIDAYS_CHRISTMAS = 'HOLIDAYS_CHRISTMAS',
	HOLIDAYS_EASTER = 'HOLIDAYS_EASTER',
	HOLIDAYS_FALL = 'HOLIDAYS_FALL',
	HOLIDAYS_KROKUS = 'HOLIDAYS_KROKUS',
	HOLIDAYS_SUMMER = 'HOLIDAYS_SUMMER',
	LONG_WEEKEND_ASCENSION = 'LONG_WEEKEND_ASCENSION',
	LONG_WEEKEND_PENTECOST = 'LONG_WEEKEND_PENTECOST',
	MIDWEEK = 'MIDWEEK',
	OUTSIDE_SCHOOL_HOLIDAYS = 'OUTSIDE_SCHOOL_HOLIDAYS',
	WEEKEND = 'WEEKEND',
}

export const PERIODS = [
	Period.ALL_YEAR_ROUND,
	Period.OUTSIDE_SCHOOL_HOLIDAYS,
	Period.HOLIDAYS_KROKUS,
	Period.HOLIDAYS_EASTER,
	Period.HOLIDAYS_SUMMER,
	Period.HOLIDAYS_FALL,
	Period.HOLIDAYS_CHRISTMAS,
	Period.LONG_WEEKEND_ASCENSION,
	Period.LONG_WEEKEND_PENTECOST,
	Period.WEEKEND,
	Period.MIDWEEK,
];
